import { SearchScreen } from 'app/features/search/screens'
import {
  searchArticlesQuery,
  searchBrandsQuery,
  searchOffersQuery,
} from 'app/features/search/queries'
import { addApolloState, initializeApollo } from 'lib/initialize-apollo'
import { withAuthedPage } from 'lib/session'
import { GetServerSideProps } from 'next'

export default function Page() {
  return <SearchScreen />
}

export const getServerSideProps: GetServerSideProps = withAuthedPage(async ({ req }) => {
  const user = req?.session?.user
  const client = initializeApollo({
    token: user?.token,
  })

  await client.query({
    query: searchBrandsQuery.query,
    variables: {
      ...searchBrandsQuery.defaultVariables,
    },
  })

  await client.query({
    query: searchArticlesQuery.query,
    variables: {
      ...searchArticlesQuery.defaultVariables,
    },
  })

  await client.query({
    query: searchOffersQuery.query,
    variables: {
      ...searchOffersQuery.defaultVariables,
    },
  })

  return addApolloState(client, {
    props: {
      user: user || null,
    },
  })
})
